
import React from 'react'
import img1 from '../images/JHP.jpg'
import img2 from '../images/TMTLOGO.png'
import { Container, Tabs, Tab, Row, Col, Image } from 'react-bootstrap';
function TMT(){
        return(
            <>
            <h1 class="text-center">TMT Introduction</h1>
            <Container>
                <Tabs defaultActiveKey="opening"
                id="uncontrolled-tab-example" justify>
                    <Tab eventKey="opening" title="Opening Words">
                        <Row className="justify-content-md-center">
                            <Col className="justify-content-md-center mt-1" xs={12} sm={4} md={4}><Image className="img-fluid" style={{width: "100%"}} src= {img1} height="50%" width="50%" rounded/></Col>
                            <Col>
                            <p>
                                My dear friends in Jesus Christ,
                                <br></br>
                                May the Peace of Our Lord Jesus Christ, present in the Eucharist, be with you always!
                                <br></br>&emsp;&emsp;&emsp;“Peace I leave with you; my peace I give to you. I do not give to you as the world gives. Do not let your

                                hearts be troubled, and do not let them be afraid.” (John 14:27). Our Lord said those words at the Last Supper, the

                                night He was betrayed. To the conventional observer, it may seem to be a supreme irony that a man who previously

                                spoke of peace then undergoes betrayal, torture, humiliation and finally death. In a worldly sense, true peace is a

                                utopian peace where there is no more war, violence, hatred, disease, and death. What Jesus offered and He offers to

                                you and me even to this day is a different type of peace: a peace in the midst of a storm. Think about the Apostles

                                when they were in the boat crossing the waters. As they were crossing, they were suddenly buffeted by a massive

                                storm and Jesus was asleep at the stern on a cushion! How crazy is that? It is as if He didn’t care that there was a

                                massive storm unfolding around Him and His friends. Then at the pleading of His Apostles, He stands up and with

                                His word, calms the seas. He leaves me and you with this remark, “Why are you afraid? Have you still no faith?”
                                <br></br>&emsp;&emsp;&emsp;Our faith doesn’t guarantee us that we won’t have storms in our daily life. Instead, our faith assures us of one

                                thing: God is always with us, in the clear days, in the cloudy days, and yes even in the stormy days. With our Faith,

                                comes a Peace of Christ that reigns in our hearts. This peace is unlike any other “peace” that the world gives:

                                whether a utopian peace or false messages of peace. This peace of Christ is one that endures all the challenges,

                                obstacles, and setbacks which we will face on our journey, that God will be with us no matter what.

                                <br></br>&emsp;&emsp;&emsp;For the past 30 years, through the grace of God, we have been able to humbly live up to this quote as best as

                                we could. Đoàn Tôma Thiện has provided a haven of Christ’s peace to its members. In the smiles, laughs, tears, and

                                hugs which came from the countless camps, sinh hoạts, retreats, Masses, and events, we were each touched by the

                                peace of Christ, a peace that no man can give, a peace that the world continues to falsely promise and fail to grant us.

                                Through the various personal challenges and tribulations, through the plethora of events that has shaped the world as

                                we know it, good or bad, Đoàn Tôma Thiện has remained and continues to remain true; Trung Thành, to the Peace of

                                Christ, a torch of Peace that has lit the candles of many hearts and will continue to light countless more to come.

                                As we celebrate our 30 years as a TMT family, know that this achievement is not by our own accord. It is all

                                thanks to God’s Providence and Mercy. It was His song of Peace that attracted over these years, the many Cha’s, the

                                many Huynh Trưởng, the many Trợ Tás and Phụ Huynh, and finally the many youths such as yourselves to our

                                beloved family.
                            </p>
                            </Col>
                            <p>
                                <br></br>&emsp;&emsp;&emsp;If someone were to ask me: What is worth celebrating in Đoàn Tôma Thiện? I would reply: I celebrate the

                                fact that despite all of our daily struggles and trials, TMT remains a home for each and every one of us. I celebrate

                                the fact that TMT remains a beacon of light against fear. I celebrate the fact that TMT has something that no other

                                worldly entity has, something that even the angels in heaven envy: The peace of the Eucharistic Jesus, His Body and

                                Blood, Soul and Divinity, given to us, at the Holy Sacrifice of the Mass and the countless Spiritual Communions that

                                we do in Thiếu Nhi, so that His Peace may reign in our Hearts forever.

                                <br></br>&emsp;&emsp;&emsp;So with that, let the peace and joy of Christ fill your souls as we celebrate our 30th Anniversary together!

                                Happy 30th TMT! May God give us 30 more and after that many more years to come!

                                Pax Domini sit semper vobiscum!
                            </p>
                        </Row>
                        
                    </Tab>
                    <Tab eventKey="history" title="History">
                    <Row className="justify-content-md-center">
                        <Col className="justify-content-md-center mt-1" xs={12} sm={4} md={4}><Image className="img-fluid" style={{width: "100%"}} src= {img2} height="50%" width="50%" rounded/></Col>
                        <Col>
                            <p>
                                <br></br>In the city of San Jose in 1992, a group of youths, under the leadership of the Vietnamese Eucharistic Youth Society, created a group called "Thomas Thien." The group followed the model of loyalty portrayed by a Vietnamese martyr, St. Thomas Thien, until his martyrdom.
                                <br></br><br></br>The 9th of September in 1992 was the group's first anniversary, when Father Joseph Nguyễn Ðức Trọng, who was then the head chaplain of the region, gave blessing to Nguyễn Thế Vũ as the first head coordinating-leader of Thomas Thien.

                                <br></br><br></br>Together, the coordinating leaders began to organize stimulating events, such as picnics, to pull together the Vietnamese youths. More engaging are the annual "Red Sea" training camps for the team leaders in April, the summer camps for the youth members in July, and the “Self Improvement” camps for adolescents between the ages of 15-18 in August.

                                <br></br><br></br>
                            </p>
                            </Col>
                        </Row>
                        <p>
                        <br></br><br></br>Under the leadership of the coordinating leaders, the youths also participated in the annual Christmas caroling for elders in convalescent homes. Besides partaking in various community services, the youth members also engage themselves in activities that promote the unity of the group, such as participating in the Mid-Autumn festival by performing the lion and traditional Vietnamese dances. In addition, the Thomas Thien Eucharistic Youth Society has developed a youth choir, singing for every Sunday mass, and a liturgical group to coordinate the readings of the Gospel and numerous other services in mass.

                        <br></br><br></br>Over a span of 11 years, the group has changed along side the transition of nine head coordinating leaders: Nguyễn Thanh Tùng (1993-1998), Hồ Hoàng Hiếu (1998-2000, 2008-2010, 2016-2019), Ðỗ Vũ Ngọc (2000-2002), Phạm Bình An (2002-2004), Phạm Hậu (2004-2006), Nguyển Thế-Anh (2006-2008), Phạm Duyên (2010-2013), Ðỗ Ngọc-Hưng (2013-2016), Trần David (2019-2021), Huỳnh John (2021-Present).

                        <br></br><br></br>After eight years calling the playground of Holy Trinity church a home, our youth group relocated to St. Patrick church in the year 2000. Currently, the Thomas Thien youths meet at St. Patrick church every Sunday at 1:30 p.m. and attend mass afterwards from 4:00 – 5:00 p.m.
                            </p>
                        
                    </Tab>
                    <Tab eventKey="jobs" title="Life of Huynh Truong">
                    <Row className="justify-content-md-center">
                            <Col className="justify-content-md-center mt-1">
                                <h3 align="center" >Mission of Huynh Truong</h3>
                                <p align="center">
                                    <br></br>To build the kids’ faith
                                </p>
                            </Col>
                            <Col className="justify-content-md-center mt-1">
                                <h3 align="center" >Duty of Huynh Truong</h3>
                                <p align="center">
                                    <br></br>Must live the Eucharistic Day
                                    <br></br><br></br>And show the kids how to live it
                                </p>
                            </Col>
                            <Col className="justify-content-md-center mt-1">
                                <h3 align="center" >Purpose of VEYM</h3>
                                <p align="center">
                                    <br></br>To train the youth to become the best person and the best Christian.
                                    <br></br><br></br>To organize and lead the youth to spread the Good News and to build the society

                                </p>
                            </Col>
                        </Row>
                    </Tab>
                    <Tab eventKey="works" title="What We Do For Mass">
                    <Row className="justify-content-md-center">
                            <Col className="justify-content-md-center mt-1">
                                <h3 align="center" >Phụng Vụ Thánh Thể</h3>
                                <p>
                                    <br></br>As TNTT we strive to serve God through many ways such as being 
                                    <br></br><br></br>Altar Servers: The ones serving the priests during mass to make go smoother

                                    <br></br><br></br>Lectors: Proclaimers of God Words

                                    <br></br><br></br>Extraordinary Eucharistic Ministers: Helping the Priest deliver to Body and Blood of Christ to the parishioner
                                </p>
                            </Col>
                            <Col className="justify-content-md-center mt-1">
                                <h3 align="center"> Ca Đoàn Seraphim </h3>
                                <p>
                                    <br></br>As every prayer is worth more whence it is sing. We thrive to deliver the mass in its solemnity and importance its upmost and bring the Word of God to live through music
                                    <br></br><br></br>Conductors: Control the music and singer and the flow that suit the mass

                                    <br></br><br></br>Singer: Deliver the prayer in its most beautiful form

                                    <br></br><br></br>Cantor: Lead singer of Choir that lead the melody of the music for everyone
                                </p>
                            </Col>
                        </Row>
                    </Tab>
                </Tabs>
            </Container>
            </>
        )
}
export default TMT;